import React, { Suspense } from 'react';
import { LayoutProps } from '../index';
import styled from 'styled-components';

const Section = styled.section`
	padding: 0;
	height: auto;
`;

const AppContent = (props: LayoutProps) => {
	return (
		<div className='h-auto'>
			<Suspense>
				<Section>{props.children}</Section>
			</Suspense>
		</div>
	);
};

export default React.memo(AppContent);
